import { getMomentDate } from "../utils/commonUtils";

export default class Rating {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.productVariantId = data.productVariantId || undefined;
        this.productName = data.productName || undefined;
        this.productType = data.productType || undefined;
        this.userId = data.userId || undefined;
        this.firstName = data.firstName || undefined;
        this.lastName = data.lastName || undefined;
        this.ratingValue = data.ratingValue || undefined;
        this.title = data.title || undefined;
        this.comment = data.comment || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.isApproved = data.isApproved;
        this.setReplies(data);
    }

    setReplies(data = {}) {
        this.replies = (data.replies || []).map(item => new RatingReply(item));
    }

    export() {
        return {
            id: this.id,
        }
    }
}

export class RatingReply {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.ratingId = data.ratingId || undefined;
        this.userId = data.userId || undefined;
        this.firstName = data.firstName || undefined;
        this.lastName = data.lastName || undefined;
        this.comment = data.comment || undefined;
        this.createdDate = getMomentDate(data.createdDate);
        this.isApproved = data.isApproved;
    }

    export() {
        return {
            id: this.id,
        }
    }
}